module.exports = import("https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.module.js");;